$(document).ready(function () {
    var $target = $('.prices-add-to-cart-actions');
    var $fixed = $('.fixed-bottom');
    var $button = $('.add-to-cart');
    var $page = $('.page');

    //bail early 
    if ($button.length === 0 || $target.length === 0 || $fixed.length === 0) {
        return;
    }

    var lastScrollTop = 0;
    var headerOffset = 100; //your fixed header height - this varies across shops so this is a approx estimate for all shops

    function isInViewport($el, direction) {
        if ($el.length === 0) return false;

        var elementTop = $el.offset().top;
        var elementBottom = elementTop + $el.outerHeight();

        var scrollTop = $(window).scrollTop();
        var viewportHeight = $(window).height();

        var viewportTop = scrollTop;
        var viewportBottom = scrollTop + viewportHeight;

        //adjust viewport top based on scroll direction
        if (direction === 'down') {
            viewportTop += headerOffset;
        } else if (direction === 'up') {
            viewportTop += headerOffset;
        }

        return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    function toggleFixed() {

        var currentScrollTop = $(window).scrollTop();
        var direction = currentScrollTop > lastScrollTop ? 'down' : 'up';
        lastScrollTop = currentScrollTop;

        if ($button.is(':disabled')) {
            $fixed.css('transform', 'translateY(100%)');
            $page.removeClass('has-fixed-cart');
            return;
        }

        if (isInViewport($target, direction)) {
            $fixed.css('transform', 'translateY(100%)');
            $page.removeClass('has-fixed-cart');
        } else {
            $fixed.css('transform', 'translateY(0)');
            $page.addClass('has-fixed-cart');
        }
    }

    $(window).on('scroll resize', toggleFixed);
    toggleFixed();
});


// WEBPACK FOOTER //
// ./cartridges/app_fh/cartridge/client/default/js/components/fixedAddtoCart.js